import React from "react"
import styles from "./index.module.scss"

export const PrivacyPolicy = () => (
  <div className={styles.container}>
    <h2 style={{ marginBottom: "20px" }}>PRIVACY POLICY</h2>
    <p>
      Hoplon Investment Partners LLP (“We”) are committed to protecting and
      respecting your privacy.
    </p>
    <p>
      This policy (together with our terms of use and any other documents
      referred to on it) sets out the basis on which any personal data we
      collect from you, or that you provide to us, will be processed by us.
      Please read the following carefully to understand our views and practices
      regarding your personal data and how we will treat it. By visiting our
      site you are accepting and consenting to the practices described in this
      policy.
    </p>
    <p>
      For the purpose of the Data Protection Act 1998 (the Act), the data
      controller is Hoplon Investment Partners LLP a Limited Liability
      Partnership, registered with registration number OC420515 at registered
      address 22-23 Old Burlington Street, London, W1S 2JJ
    </p>
    <div>
      <h3>Information we collect from you</h3>
    </div>
    <p>We will collect and process the following data about you:</p>
    <ul>
      <li>
        Information you give us. This is information about you that you give us
        by filling in forms on our site Hoplonpartners.com (our site) or by
        corresponding with us by phone, e-mail or otherwise. It includes
        information you provide when you contact us and when you report a
        problem with our site. The information you give us may include your
        name, address, e-mail address and phone number, commercial information,
        financial and credit card information
      </li>
      <li>
        Information we collect about you. With regard to each of your visits to
        our site we will automatically collect the following information:
      </li>
      <li>
        technical information, including the Internet protocol (IP) address used
        to connect your computer to the Internet,
      </li>
      <li>
        information about your visit, including [the full Uniform Resource
        Locators (URL), clickstream to, through and from our site (including
        date and time), [page response times, [download errors, length of visits
        to certain pages page interaction information (such as scrolling,
        clicks, and mouse-overs), methods used to browse away from the page and
        any phone number used to call our customer service number.
      </li>
      <li>
        Information we receive from other sources. This is information we
        receive about you if you use any of the other websites we operate or the
        other services we provide. We are working closely with third parties
        (including, for example, business partners, sub-contractors in
        technical, payment and delivery services, advertising networks,
        analytics providers, search information providers, credit reference
        agencies). We will notify you when we receive information about you from
        them and the purposes for which we intend to use that information.
      </li>
    </ul>
    <div>
      <h3>Cookies</h3>
    </div>
    <p>
      Our website uses cookies to distinguish you from other users of our
      website. This helps us to provide you with a good experience when you
      browse our website and also allows us to improve our site. For detailed
      information on the cookies we use and the purposes for which we use them
      please contact GDPR@hoplonpartners.com.
    </p>
    <div>
      <h3>Uses made of the information</h3>
    </div>
    <p>We use information held about you in the following ways:</p>
    <ul>
      <li>Information you give to us. We will use this information:</li>
      <li>
        to carry out our obligations arising from any contracts entered into
        between you and us and to provide you with the information, products and
        services that you request from us;
      </li>
      <li>
        to provide you with information about other goods and services we offer
        that are similar to those that you have already purchased or enquired
        about;
      </li>
      <li>
        to provide you, or permit selected third parties to provide you, with
        information about goods or services we feel may interest you. If you are
        an existing customer, we will only contact you by electronic means
        (e-mail or SMS) with information about goods and services similar to
        those which were the subject of a previous sale or negotiations of a
        sale to you. If you are a new customer, and where we permit selected
        third parties to use your data, we (or they) will contact you by
        electronic means only if you have consented to this. If you do not want
        us to use your data in this way, or to pass your details on to third
        parties for marketing purposes, please tick the relevant box situated on
        the form on which we collect your data (the [order form OR registration
        form]);
      </li>
      <li>to notify you about changes to our service;</li>
      <li>
        to ensure that content from our site is presented in the most effective
        manner for you and for your computer.
      </li>
      <li>Information we collect about you. We will use this information:</li>
      <li>
        to administer our site and for internal operations, including
        troubleshooting, data analysis, testing, research, statistical and
        survey purposes;
      </li>
      <li>
        to improve our site to ensure that content is presented in the most
        effective manner for you and for your computer;
      </li>
      <li>
        to allow you to participate in interactive features of our service, when
        you choose to do so;
      </li>
      <li>as part of our efforts to keep our site safe and secure;</li>
      <li>
        to measure or understand the effectiveness of advertising we serve to
        you and others, and to deliver relevant advertising to you;
      </li>
      <li>
        to make suggestions and recommendations to you and other users of our
        site about goods or services that may interest you or them.
      </li>
      <li>
        Information we receive from other sources. We will combine this
        information with information you give to us and information we collect
        about you. We will use this information and the combined information for
        the purposes set out above (depending on the types of information we
        receive).
      </li>
    </ul>
    <div>
      <h3>Disclosure of your information</h3>
    </div>
    <p>
      You agree that we have the right to share your personal information with:
    </p>
    <ul>
      <li>
        Any member of our group, which means our subsidiaries, our ultimate
        holding company and its subsidiaries, as defined in section 1159 of the
        UK Companies Act 2006.
      </li>
      <li>Selected third parties including:</li>
      <li>
        business partners, suppliers and sub-contractors for the performance of
        any contract we enter into with you
      </li>
      <li>
        analytics and search engine providers that assist us in the improvement
        and optimisation of our site;
      </li>
      <li>
        credit reference agencies for the purpose of assessing your credit score
        where this is a condition of us entering into a contract with you.
      </li>
    </ul>
    <p>We will disclose your personal information to third parties:</p>
    <ul>
      <li>
        In the event that we sell or buy any business or assets, in which case
        we will disclose your personal data to the prospective seller or buyer
        of such business or assets.
      </li>
      <li>
        If Hoplon Investment Partners LLP or substantially all of its assets are
        acquired by a third party, in which case personal data held by it about
        its customers will be one of the transferred assets.
      </li>
      <li>
        If we are under a duty to disclose or share your personal data in order
        to comply with any legal obligation, or in order to enforce or apply our
        terms of use and other agreements; or to protect the rights, property,
        or safety of Hoplon Investment Partners LLP our customers, or others.
        This includes exchanging information with other companies and
        organisations for the purposes of fraud protection and credit risk
        reduction.
      </li>
    </ul>
    <div>
      <h3>Where we store your personal data</h3>
    </div>
    <p>
      We will take all steps reasonably necessary to ensure that your data is
      treated securely and in accordance with this privacy policy. All
      information you provide to us is stored on our secure servers. Any payment
      transactions will be encrypted. Where we have given you (or where you have
      chosen) a password which enables you to access certain parts of our site,
      you are responsible for keeping this password confidential. We ask you not
      to share a password with anyone.
    </p>
    <p>
      Unfortunately, the transmission of information via the internet is not
      completely secure. Although we will do our best to protect your personal
      data, we cannot guarantee the security of your data transmitted to our
      site; any transmission is at your own risk. Once we have received your
      information, we will use strict procedures and security features to try to
      prevent unauthorised access.
    </p>
    <div>
      <h3>Your rights</h3>
    </div>
    <p>
      You have the right to ask us not to process your personal data for
      marketing purposes. We will usually inform you (before collecting your
      data) if we intend to use your data for such purposes or if we intend to
      disclose your information to any third party for such purposes. You can
      exercise your right to prevent such processing by checking certain boxes
      on the forms we use to collect your data. You can also exercise the right
      at any time by contacting us
    </p>
    <p>
      Our site may, from time to time, contain links to and from the websites of
      our partner networks, advertisers and affiliates. If you follow a link to
      any of these websites, please note that these websites have their own
      privacy policies and that we do not accept any responsibility or liability
      for these policies. Please check these policies before you submit any
      personal data to these websites.
    </p>
    <div>
      <h3>Access to information</h3>
    </div>
    <p>
      The Act gives you the right to access information held about you. Your
      right of access can be exercised in accordance with the Act. Any access
      request will be subject to a fee of £10 to meet our costs in providing you
      with details of the information we hold about you.
    </p>
    <div>
      <h3>Changes to our privacy policy</h3>
    </div>
    <p>
      Any changes we make to our privacy policy in the future will be posted on
      this page and, where appropriate, notified to you by e-mail. Please check
      back frequently to see any updates or changes to our privacy policy.
    </p>
    <div>
      <h3>Contact</h3>
    </div>
    <p>
      Questions, comments and requests regarding this privacy policy are
      welcomed and should be addressed to GDPR@Hoplonpartners.com
    </p>
  </div>
)
